<div class="sc-performance-grid">
    <cmps-container-header
        class="cmps-performance-grid-header-event text-center"
        [headerColour]="widget.headerColour"
        [textColour]="widget.textColour"
    >
        {{ widget.name }}
    </cmps-container-header>
    <div
        class="my-3 mx-auto text-center"
        *ngIf="!model?.rows || model?.rows.length === 0"
    >
        {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
    </div>

    <div
        ngGrid
        [rendererOptions]="_rendererOpts"
        [selectTemplate]="_selectTpl"
        [rows]="model?.rows"
        [sortDefs]="model?.sortDefs"
        (willInflate)="_onWillInflate()"
        (didInflate)="_onDidInflate()"
        *ngIf="model?.rows?.length !== 0"
    >
        <ng-template
            gridContent
            data-type="grid"
        >
            <div></div>
        </ng-template>

        <ng-template
            gridContent
            data-type="row"
            let-ctx="ctx"
        >
            <div
                [class.last-row-of-pillar]="ctx?.isLastRowOfPillar"
                [class.row-of-pillar]="!ctx?.isLastRowOfPillar"
            ></div>
        </ng-template>

        <!--TODO can pass column name here, or column header can be a component to further reduce repetition-->
        <ng-template
            let-c="c"
            #sortTpl
        >
            <button class="align-self-start">
                <cmps-icon
                    class="cmps-cdk-fill-black"
                    [svgIcon]="
                        model?.sortDefs[0].order === _SortOrder.ASC
                            ? 'chevron-up'
                            : 'chevron-down'
                    "
                    *ngIf="
                        model?.sortDefs &&
                        model?.sortDefs.length &&
                        model?.sortDefs[0].columnId === c.id
                    "
                ></cmps-icon>
                <cmps-icon
                    class="cmps-cdk-fill-black"
                    svgIcon="unfold-more-horizontal"
                    *ngIf="
                        !model?.sortDefs ||
                        !model?.sortDefs.length ||
                        model?.sortDefs[0].columnId !== c.id
                    "
                ></cmps-icon>
            </button>
        </ng-template>
        <ng-template
            gridContent
            data-type="cell"
            data-id="header"
            let-c="c"
            let-ctx="ctx"
        >
            <div [ngSwitch]="ctx.type">
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.PILLAR"
                >
                    <span>{{ _i18n._9255_PILLAR | translate }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.METRIC_NAME"
                >
                    <span>{{ _i18n._7146_METRIC_NAME | translate }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    [cmpsTooltipTrigger]="
                        _i18n._9274_ACTUAL_DESCRIPTION | translate
                    "
                    trigger="hover"
                    *ngSwitchCase="_ColumnType.ACTUAL"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._725_ACTUAL | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.TARGET"
                    [cmpsTooltipTrigger]="
                        _i18n._9275_TARGET_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._726_TARGET | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.PERCENT_TO_TARGET"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._768___TO_TARGET | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.WEIGHT"
                    [cmpsTooltipTrigger]="
                        _i18n._9277_WEIGHT_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9256_WEIGHT | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.ORIGINAL_POINTS"
                    [cmpsTooltipTrigger]="
                        _i18n._9278_ORIGINAL_POINTS_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9257_ORIGINAL_POINTS | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.ADJUSTED_POINTS"
                    [cmpsTooltipTrigger]="
                        _i18n._9279_ADJUSTED_POINTS_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9258_ADJUSTED_POINTS | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.METRIC_SCORE"
                    [cmpsTooltipTrigger]="
                        _i18n._9280_METRIC_SCORE_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9259_METRIC_SCORE | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.METRIC_RANK"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9260_METRIC_RANK | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.POINTS_BAND"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9261_POINTS_BAND | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.N_TILE"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9262_N_TILE | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.N_TILE_BAND"
                    [cmpsTooltipTrigger]="
                        _i18n._9284_N_TILE_BAND_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9263_N_TILE_BAND | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.ACTUAL_TYPE"
                    [cmpsTooltipTrigger]="
                        _i18n._9285_ACTUAL_TYPE_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9264_ACTUAL_TYPE | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.TARGET_TYPE"
                    [cmpsTooltipTrigger]="
                        _i18n._9286_TARGET_TYPE_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9265_TARGET_TYPE | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.PERCENT_TYPE"
                    [cmpsTooltipTrigger]="
                        _i18n._9287_PERCENT_TYPE_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9266_PERCENT_TYPE | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.SCORING_TYPE"
                    [cmpsTooltipTrigger]="
                        _i18n._9288_SCORING_TYPE_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9267_SCORING_TYPE | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.ACTUAL_TREND"
                    [cmpsTooltipTrigger]="
                        _i18n._9289_ACTUAL_TREND_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9268_ACTUAL_TREND | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.PERCENT_TO_TARGET_TREND"
                    [cmpsTooltipTrigger]="
                        _i18n._9290_TO_TARGET_TREND_DESCRIPTION | translate
                    "
                    trigger="hover"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9269___TO_TARGET_TREND | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.COACHING_PLAN_ACTIVE"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9270_COACHING_PLAN_ACTIVE | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
                <div
                    class="sc-grid-table-header"
                    (click)="_onSortClick(c)"
                    *ngSwitchCase="_ColumnType.METRIC_LABEL"
                >
                    <span>{{
                        ctx.nameOverride
                            ? ctx.nameOverride
                            : (_i18n._9271_METRIC_LABEL | translate)
                    }}</span>
                    <div class="sc-grid-table-header-sorting-icon">
                        <ng-container
                            *ngTemplateOutlet="sortTpl; context: { c: c }"
                        ></ng-container>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template
            gridContent
            data-type="cell"
            data-id="content"
            let-c="c"
            let-ctx="ctx"
        >
            <div [ngSwitch]="c.ctx.type">
                <div
                    class="sc-grid-table-content-pillar"
                    *ngSwitchCase="_ColumnType.PILLAR"
                >
                    <span>{{ ctx?.pillar.name || '-' }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.METRIC_NAME"
                >
                    <span>{{
                        ctx.data?.metricName ||
                            ctx.data?.metricShortName ||
                            ctx.data?.metricInitials ||
                            '-'
                    }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.ACTUAL"
                >
                    <span [style.color]="ctx.data?.targetThresholdColour">
                        {{
                            ctx.data?.actual == null
                                ? '-'
                                : (ctx.data?.actual | number: '1.2-2')
                        }}
                    </span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.TARGET"
                >
                    <span>{{
                        ctx.data?.target == null
                            ? '-'
                            : (ctx.data?.target | number: '1.2-2')
                    }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.PERCENT_TO_TARGET"
                >
                    <span [style.color]="ctx.data?.targetThresholdColour">
                        {{
                            ctx.data?.targetPercent == null
                                ? '-'
                                : (ctx.data?.targetPercent | percent: '1.2-2')
                        }}
                    </span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.WEIGHT"
                >
                    <span>{{
                        ctx.data?.weight == null
                            ? '-'
                            : (ctx.data?.weight | percent: '1.2-2')
                    }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.ORIGINAL_POINTS"
                >
                    <span>{{
                        ctx.data?.originalPoints == null
                            ? '-'
                            : (ctx.data?.originalPoints | number: '1.2-2')
                    }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.ADJUSTED_POINTS"
                >
                    <span>{{
                        ctx.data?.adjustedPoints == null
                            ? '-'
                            : (ctx.data?.adjustedPoints | number: '1.2-2')
                    }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.METRIC_SCORE"
                >
                    <span>{{
                        ctx.data?.metricScore == null
                            ? '-'
                            : (ctx.data?.metricScore | number: '1.2-2')
                    }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.METRIC_RANK"
                >
                    <span>{{ ctx.data?.metricRankSg || '-' }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.POINTS_BAND"
                >
                    <span>{{ ctx.data?.pointsBand || '-' }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.N_TILE"
                >
                    <span>{{
                        ctx.data?.nTile == null
                            ? '-'
                            : (ctx.data?.nTile | number: '1.2-2')
                    }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.N_TILE_BAND"
                >
                    <span>{{ ctx.data?.nTileBand || '-' }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.ACTUAL_TYPE"
                >
                    <span>{{ ctx.data?.actualType || '-' }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.TARGET_TYPE"
                >
                    <span>{{ ctx.data?.targetType || '-' }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.PERCENT_TYPE"
                >
                    <span>{{ ctx.data?.percentType || '-' }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.SCORING_TYPE"
                >
                    <span>{{ ctx.data?.scoreType || '-' }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.ACTUAL_TREND"
                >
                    <span
                        [style.color]="ctx.data?.actualTrendThresholdColour"
                        >{{
                            ctx.data?.actualTrend
                                | cmpsNumberWithSign: 'p' : '1.2-2' : true : '+'
                        }}</span
                    >
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.PERCENT_TO_TARGET_TREND"
                >
                    <span
                        [style.color]="
                            ctx.data?.targetPercentTrendThresholdColour
                        "
                        >{{
                            ctx.data?.targetPercentTrend
                                | cmpsNumberWithSign: 'p' : '1.2-2' : true : '+'
                        }}</span
                    >
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.COACHING_PLAN_ACTIVE"
                >
                    <span>{{
                        (ctx.data?.coachingPlanActive
                            ? _i18n._9297_YES
                            : _i18n._9298_NO
                        ) | translate
                    }}</span>
                </div>
                <div
                    class="sc-grid-table-content"
                    *ngSwitchCase="_ColumnType.METRIC_LABEL"
                >
                    <span>-</span>
                </div>
            </div>
        </ng-template>
    </div>
    <div class="row">
        <div class="col-6">
            <cmps-messages
                [messages]="messages"
                [attributes]="messageAttributes"
            ></cmps-messages>
        </div>
    </div>
</div>
